import { render, staticRenderFns } from "./ClientAveragePaymentDurationReport.vue?vue&type=template&id=02ba817c&"
import script from "./ClientAveragePaymentDurationReport.vue?vue&type=script&lang=js&"
export * from "./ClientAveragePaymentDurationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports